<template lang="pug">
  .d-flex.min-h-100vh.auth-layout
    slot(name="svg-icons")
    .d-flex.flex-column.w-100
      .d-flex.align-items-center.flex-1
        .container.w-100.pt-4
          .bg-auth.of-h.shadow.rounded.pos-r
            .pin.pin-xy.bg-black(ref="bgMask")
              //- mask to hide background image `.bg-auth`

            .d-flex.min-h-500.pos-r.p-0.w-100
              .text-center.pin.pin-center
                div
                  app-logo(ref="svgAppLogo").size-100px
                .pin.pin-x-center.w-175.b-n50
                  app-logo-text(ref="svgAppLogoText" init-auth-anim)
                .pin.pin-x-center.w-175.b-n75
                  .partOf.fs-10(ref="partOf") a part of Hub-Suite
              main(role="main" ref="mainContent").d-flex.flex-1
                .row.align-items-center.flex-1
                  .col-md-7.mb-5.mb-md-0.text-center
                    .pt-4.pb-2
                      .px-2.mb-4
                        app-logo.size-100px
                      .mb-3
                        app-logo-text.max-w-320
                      .pos-r.max-w-280.mx-auto
                        .partOf a part of Hub-Suite

                  .col-md-5
                    .px-4.py-5.text-center
                      router-view
                        //- all auth related forms will rednder here

      .pt-2.pb-3.text-center
        a(href="https://www.hub-suite.com/terms-of-use/" target="_blank").text-white.text-uppercase
          | Terms of Use
        span.text-muted.mx-3 •
        a(href="https://www.hub-suite.com/privacy/" target="_blank").text-white.text-uppercase
          | Privacy Policy
</template>

<script>
import { TimelineLite } from 'gsap/dist/gsap';
import AppLogo from '@/components/logos/AppLogo.vue';
import AppLogoText from '@/components/logos/AppLogoText.vue';

export default {
  name: 'AuthView',

  components: {
    AppLogo,
    AppLogoText,
  },

  mounted() {
    this.initTextAnim();
    this.initLogoAnim();
  },

  methods: {
    initTextAnim() {
      const { svgAppLogoText, partOf, bgAuth } = this.$refs;
      const paths = svgAppLogoText.$refs.appLogoTextPaths.querySelectorAll('path');
      const pathsReversed = Object.assign([], paths).reverse();

      const style = {
        /* eslint-disable object-curly-newline */
        stateSet: { opacity: 0, scale: 0.9, color: '#000', fill: '#000' },
        state1A: { opacity: 1, fill: '#5a96e9', scale: 1, delay: 0.25 },
        state1B: { opacity: 1, fill: '#fff', scale: 1 },
        state2: { opacity: 1, color: '#fff', scale: 1 },
        state3: { opacity: 0, fill: '#000', scale: 0.9, delay: 1.25 },
        /* eslint-enable */
      };

      const timeline = new TimelineLite();

      timeline
        .set([paths, partOf], style.stateSet)
        .set(bgAuth, { backgroundColor: '#000' })
        .staggerTo(paths[0], 0.5, style.state1A)
        .staggerTo(paths[1], 0.5, style.state1B)
        .staggerTo(partOf, 0.3, style.state2)
        .staggerTo([partOf, pathsReversed], 0.5, style.state3);
    },

    initLogoAnim() {
      const { mainContent, svgAppLogo, bgMask } = this.$refs;
      const { appLogo } = svgAppLogo.$refs;

      const timeline = new TimelineLite();

      timeline
        .set(mainContent, { opacity: 0 })

        .to(appLogo, 0.5, { opacity: 0 }, 3.5)
        .to(mainContent, 0.5, { opacity: 1 }, 4)
        .to(bgMask, 1, { opacity: 0 }, 4);
    },
  },
};
</script>
